import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
} from "@mui/material"

export default function ConfirmationDialog({ open, onClose, onConfirm }) {
	return (
		<Dialog open={open} onClose={onClose}>
			<DialogTitle>Confirm Action</DialogTitle>
			<DialogContent>
				<DialogContentText>
					Are you sure you want to perform this action?
				</DialogContentText>
			</DialogContent>
			<DialogActions>
				<Button onClick={onClose} color="primary">
					Cancel
				</Button>
				<Button onClick={onConfirm} color="primary">
					Confirm
				</Button>
			</DialogActions>
		</Dialog>
	)
}
